import { GlyphLoading } from "#root/components/glyphs";
import LogViewer from "#root/components/log-viewer";
import { useData } from "#root/utility/hooks";
import type { ReactNode } from "react";
import { feedCollection } from "#root/schema/platform/newsrpm-parser";
import PageLayout from "./layout";

export default function FeedPreview({ feedId }): ReactNode {
  const [details] = useData(async () => {
    if (feedId) {
      return feedCollection.details(feedId);
    }
  }, [feedId]);

  if (!details) {
    return <GlyphLoading/>;
  }

  const { row } = details;

  return (
    <PageLayout title="NewsRPM Parser - View Feed">
      <section>
        <h2>Feed {feedId}</h2>
        <table className="dl">
          <tbody>
          <tr>
            <th>providerCode</th>
            <td>{row.providerCode}</td>
          </tr>
          <tr>
            <th>provider</th>
            <td>{row.provider}</td>
          </tr>
          <tr>
            <th>uri</th>
            <td>{row.uri}</td>
          </tr>
          <tr>
            <th>bodySource</th>
            <td>{row.bodySource}</td>
          </tr>
          <tr>
            <th>feedType</th>
            <td>{row.feedType}</td>
          </tr>
          <tr>
            <th>originator</th>
            <td>{row.originator}</td>
          </tr>
          <tr>
            <th>feedHandler</th>
            <td>{row.feedHandler}</td>
          </tr>
          <tr>
            <th>legacyChannelId</th>
            <td>{row.legacyChannelId}</td>
          </tr>
          <tr>
            <th>feedOptions</th>
            <td>{JSON.stringify(row.feedOptions)}</td>
          </tr>
          <tr>
            <th>retrieveEvery</th>
            <td>{row.retrieveEvery}</td>
          </tr>
          <tr>
            <th>lastRetrieval</th>
            <td>{row.lastRetrieval}</td>
          </tr>
          <tr>
            <th>nextRetrieval</th>
            <td>{row.nextRetrieval}</td>
          </tr>
          <tr>
            <th>lastError</th>
            <td>{row.lastError}</td>
          </tr>
          <tr>
            <th>lastSuccessfulRetrieval</th>
            <td>{row.lastSuccessfulRetrieval}</td>
          </tr>
          </tbody>
        </table>
        <h2>Last Log</h2>
        <LogViewer log={row.lastLog ?? "[No logged output]"}/>
      </section>
    </PageLayout>
  );
}
